module.exports = __webpack_public_path__ + "static/img/9.434098f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/2/sp/9.png
// module id = YK9t
// module chunks = 0